import { useEffect, useState } from "react";
import api from "@/lib/api";
import EventFeed from "@/components/EventFeed";
import RaidWheel, { computeRot } from "@/components/RaidWheel";

export default function GameOverlay() {
  const [wheel, setWheel] = useState(null);
  const overlayKey = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "").get("key") || "";
  const [keyOk, setKeyOk] = useState(null);

  useEffect(() => {
    if (overlayKey) api.defaults.headers.common["X-Overlay-Key"] = overlayKey;
    api.get(`/overlay/check?k=${encodeURIComponent(overlayKey)}`)
      .then((r) => setKeyOk(!!r.data.valid))
      .catch(() => setKeyOk(false));
  }, []);

  const triggerWheel = (m) => {
    setWheel({ multiplier: m, rot: 0 });
    setTimeout(() => setWheel({ multiplier: m, rot: computeRot(m) }), 60);
    setTimeout(() => setWheel(null), 8000);
  };

  if (keyOk === false) {
    return (
      <div style={{ background: "transparent" }} className="min-h-screen w-full flex items-center justify-center" data-testid="overlay-locked">
        <div className="text-center px-6 py-5 rounded-2xl bg-[#0a0a0a]/90 border border-white/10">
          <div className="text-primary text-sm font-heading font-800 tracking-widest mb-1">OVERLAY LOCKED</div>
          <p className="text-xs text-muted-foreground max-w-xs">Open this overlay using the private link from your dashboard (OBS Overlay tab).</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: "transparent" }} className="min-h-screen w-full p-6 relative">
      {keyOk === true && <EventFeed className="items-end ml-auto" onWheel={triggerWheel} />}
      <RaidWheel wheel={wheel} />
    </div>
  );
}
